module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-us"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('h4', [_vm._v("Arrange a call.")]), _vm._v(" "), _c('q-input', {
    staticStyle: {
      "{display": "block-inline}"
    },
    attrs: {
      "float-label": "Full name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('q-input', {
    attrs: {
      "float-label": "Phone number",
      "type": "tel"
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "5vh"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('q-btn', {
    attrs: {
      "pull-right": "",
      "icon": "create",
      "outline": ""
    }
  }, [_vm._v("Request a call")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10vh"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9929a2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactUs.vue
// module id = 24
// module chunks = 0